module.exports = __webpack_public_path__ + "static/media/1985.9f9b4ad7.svg";